import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckList from '@/components/CheckList.vue';
import MyDialog from '@/components/MyDialog.vue';
import { chain, mapValues } from 'lodash';
import MySelect from '@/components/MySelect.vue';
let CharacterSheetRest = class CharacterSheetRest extends Vue {
    constructor() {
        super(...arguments);
        this.hitDiceToUse = {};
        this.isRestOpen = false;
        this.dieResult = 0;
        this.mode = 'Short Rest';
    }
    get numHitDiceToUse() {
        return Object.values(this.hitDiceToUse).reduce((sum, count) => sum + count, 0);
    }
    get conHealing() {
        return this.numHitDiceToUse * this.hitPoints.resting.hitDieBonus;
    }
    get totalHealing() {
        return this.conHealing + this.dieResult;
    }
    resetCount() {
        this.mode = 'Short Rest';
        this.dieResult = 0;
        this.hitDiceToUse = chain(this.hitPoints.hitDice)
            .keyBy('size')
            .mapValues(() => 0)
            .value();
    }
    setCount(size, numSelected) {
        Vue.set(this.hitDiceToUse, size, numSelected);
        if (this.numHitDiceToUse === 0)
            this.dieResult = 0;
    }
    takeRest() {
        if (this.mode === 'Short Rest')
            this.takeShortRest();
        else
            this.takeLongRest();
        this.isRestOpen = false;
    }
    takeShortRest() {
        const featuresTimesUsed = chain(this.hitPoints.resting.shortRestFeatures)
            .map(i => ({ key: i, val: 0 }))
            .keyBy('key')
            .mapValues('val')
            .value();
        this.$emit('updateCharacter', { currentStats: {
                hitPointsLost: Math.max(0, this.hitPoints.maximum - this.hitPoints.current - this.totalHealing),
                techPointsUsed: 0,
                superiorityDiceUsed: 0,
                hitDiceUsed: mapValues(this.hitDiceToUse, (numSpent, spentSize) => {
                    const dice = this.hitPoints.hitDice.find(({ size }) => size === spentSize);
                    return dice ? dice.maximum - dice.current + numSpent : 0;
                }),
                featuresTimesUsed
            } });
    }
    takeLongRest() {
        const featuresTimesUsed = chain(this.hitPoints.resting.longRestFeatures)
            .map(i => ({ key: i, val: 0 }))
            .keyBy('key')
            .mapValues('val')
            .value();
        const hitDiceUsed = chain(this.hitPoints.hitDice).map(({ size, current, maximum }) => {
            const restored = this.hitPoints.resting.hitDiceRestored.find(restored => restored.size === size);
            return { size, used: maximum - current - (restored ? restored.numRestored : 0) };
        }).keyBy('size').mapValues('used').value();
        this.$emit('updateCharacter', { currentStats: {
                hitPointsLost: 0,
                temporaryHitPoints: 0,
                techPointsUsed: 0,
                forcePointsUsed: 0,
                superiorityDiceUsed: 0,
                hitDiceUsed,
                featuresTimesUsed,
                highLevelCasting: {
                    level6: false,
                    level7: false,
                    level8: false,
                    level9: false
                }
            } });
    }
    pluralize(count, word) {
        return `${count} ${word}${count === 1 ? '' : 's'}`;
    }
};
__decorate([
    Prop(Object)
], CharacterSheetRest.prototype, "hitPoints", void 0);
CharacterSheetRest = __decorate([
    Component({
        components: {
            CheckList,
            MyDialog,
            MySelect
        }
    })
], CharacterSheetRest);
export default CharacterSheetRest;
